module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c006"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('b', [_vm._v("c. 1470")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter0"
  }, [_vm._v("Cipher Disk")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent_line"
  }, [_c('b', [_vm._v("Leon Battista Alberti")]), _vm._v(" (1404–1472)"), _c('b', [_vm._v(", Blaise de Vigenère")]), _vm._v(" (1523–1596)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Also known by the name “formula,” Leon Battista Alberti’s disk is one of the first examples of a mechanical device designed to encrypt language. It comprises two concentric copper circles, with the alphabet ringing each in the proper order. Each letter is spaced evenly from the next on its own circle, while also being aligned with the letter in the other circle below or above it. The outer ring is fixed; the inner ring spins, aligning different letters with the fixed (and properly ordered) alphabet above it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To encode a message, one aligns a letter from the inner circle with a specific letter on the outer circle. This is known as the "), _c('i', [_vm._v("index.")]), _vm._v(" The rest of the alphabet in the inner circle is now aligned with new letters in the alphabet. One then encodes the written content according to the new substitutes. This type of encryption is called a "), _c('i', [_vm._v("polyalphabetic substitution cipher.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Small modifications can make the message much harder to crack. For example, Alberti might have used an "), _c('i', [_vm._v("L")]), _vm._v(" as the index for the first part of his message and then alerted the decipherer with a secret signal that he switched the index to, say, "), _c('i', [_vm._v("P")]), _vm._v(" at a later point in the message. Without knowledge of those rules, it was extremely difficult (at the time) to crack the cipher, because the approach of using letter-frequency distribution—drawing a correspondence between the most common plain-text letters and the most common ciphertext letters to crack the substitution cipher—was not widely known. He described his cipher invention in his 1467 treatise, "), _c('i', [_vm._v("De Cifris.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Variations of Alberti’s cipher disk have been designed over the years, including by Blaise de Vigenère, who took Alberti’s concentric circles and turned them into a table that illustrated all of the possible substitutions for each letter. Vigenère’s version was cracked by Charles Babbage around 1854.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alberti came from a prosperous Italian family that made its wealth from banking and commerce. His interests and expertise were far greater than just mathematics: he also contributed to the fields of architecture, linguistics, poetry, philosophy, and law, in which he had a degree. Among his many notable achievements, he was appointed to be an architectural adviser to the Vatican in 1447 for Pope Nicholas V.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c005_r1"
    }
  }, [_c('i', [_vm._v("On Deciphering Cryptographic Messages")]), _vm._v(" (c. 850)")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c027_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vernam Cipher (1917)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("US Army Surgeon Albert J. Myer created this cipher disk, c. 1861–1865, to protect communications from the Union Army. The disk functioned by aligning the letters on the upper two rings with the numbers on the two lower ones.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/27-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b9f2f8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c006_r1.vue
// module id = 90
// module chunks = 0